import httpService from "@/utils/httpService";

const url = "api/models";

export default {
  get(options) {
    return httpService.get({ url: `${url}`, params: options });
  },
  getMasters(options) {
    return httpService.get({ url: `${url}/getMasters`, params: options });
  },
  getMasterVersions(facilityId, config = {}) {
    return httpService.get({ url: `${url}/${facilityId}/getMasterVersions`, ...config });
  },
  getModelVersions(facilityId, modelId) {
    return httpService.get({ url: `${url}/${facilityId}/getModelVersions/${modelId}` });
  },
  delete(facilityId, id) {
    return httpService.delete({
      url: `api/forge/oss/objects?assetId=${facilityId}&id=${id}&isSmallModel=true`
    });
  },
  updateModelStatus(id, status) {
    return httpService.put({
      url: `${url}/updateModelStatus`,
      data: { id, status },
    });
  },
  translateToRegion(assetId, modelId, targetRegion) {
    return httpService.post({
      url: `api/assets/${assetId}/models/${modelId}/translate-to-region`,
      data: { targetRegion },
    });
  }
}